import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function updateFacility({ payload, systemUserId, realmID, id }) {
  try {
    const url = paths.getOrganizationProfile(systemUserId, realmID,id); 
    const response = await axiosInstance.post(url, payload); 
    return response.data; 
  } catch (error) {
    return Promise.reject(error);
  }
}

const useUpdateFacility = () => {
  return useMutation({
    mutationFn: updateFacility, 
  });
};

export { useUpdateFacility };